export function openCart(getComponentExists, openOverlay) {
  if (typeof getComponentExists !== 'function' || typeof openOverlay !== 'function') {
    return
  }
  if (getComponentExists('cart-drawer')) {
    openOverlay({
      component: 'cart-drawer',
      ignoreDismissed: true,
      namespace: 'cartDrawer',
    })
  } else if (getComponentExists('cart-notice')) {
    openOverlay({
      namespace: 'cartNotice',
      ignoreDismissed: true,
    })
  }
}
